const ContractualIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.125 10.125H7.625M5.125 7.625H10.125M5.125 5.125H10.125M14.4434 10.1244H10.125V14.4431M9.86612 14.5H1.375C1.20924 14.5 1.05027 14.4342 0.933058 14.3169C0.815848 14.1997 0.75 14.0408 0.75 13.875V1.375C0.75 1.20924 0.815848 1.05027 0.933058 0.933058C1.05027 0.815848 1.20924 0.75 1.375 0.75H13.875C14.0408 0.75 14.1997 0.815848 14.3169 0.933058C14.4342 1.05027 14.5 1.20924 14.5 1.375V9.86612C14.5 9.94819 14.4838 10.0295 14.4524 10.1053C14.421 10.1811 14.375 10.25 14.3169 10.3081L10.3081 14.3169C10.25 14.375 10.1811 14.421 10.1053 14.4524C10.0295 14.4838 9.94819 14.5 9.86612 14.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ContractualIcon;
